import { IconPropsType } from './types/IconsProps.type';

type IconClockHistoryProps = & IconPropsType

export const ClockHistoryIcon = ({
    width = 19,
    height = 18,
    className = '',
    style = {},
    fillColor = 'currentColor',
}: IconClockHistoryProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={style}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.97706 1.88875C5.04971 1.88875 1.86597 5.07249 1.86597 8.99984C1.86597 12.9272 5.04971 16.1109 8.97706 16.1109C10.4398 16.1109 11.7976 15.67 12.9273 14.9138C13.2025 14.7296 13.575 14.8034 13.7592 15.0786C13.9435 15.3539 13.8697 15.7264 13.5945 15.9106C12.2736 16.7948 10.6846 17.3104 8.97706 17.3104C4.38727 17.3104 0.666504 13.5896 0.666504 8.99984C0.666504 4.41005 4.38727 0.689285 8.97706 0.689285C13.1105 0.689285 16.5392 3.707 17.1801 7.65949L17.9773 6.86225C18.2115 6.62804 18.5913 6.62804 18.8255 6.86225C19.0597 7.09646 19.0597 7.47619 18.8255 7.7104L17.112 9.42392C16.8959 9.64 16.5519 9.65906 16.3132 9.46816L14.1713 7.75464C13.9127 7.54773 13.8708 7.17032 14.0777 6.91168C14.2846 6.65304 14.662 6.6111 14.9206 6.81802L15.9601 7.64961C15.3294 4.36797 12.4427 1.88875 8.97706 1.88875ZM8.97706 4.11632C9.30829 4.11632 9.57679 4.38483 9.57679 4.71605V9.48595L12.6723 11.0337C12.9686 11.1818 13.0886 11.5421 12.9405 11.8383C12.7924 12.1346 12.4321 12.2547 12.1359 12.1065L8.70885 10.393C8.50568 10.2914 8.37733 10.0838 8.37733 9.8566V4.71605C8.37733 4.38483 8.64584 4.11632 8.97706 4.11632Z"
                fill={fillColor}
            />
        </svg>
    );
};
